import { render, staticRenderFns } from "./CustomerSearchInput.vue?vue&type=template&id=16b3d63a&"
import script from "./CustomerSearchInput.vue?vue&type=script&lang=js&"
export * from "./CustomerSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports